import { Text } from '@chakra-ui/react'
import { useAccount } from '@lib/context/account-context'
import ChevronDown from '@modules/common/icons/chevron-down'
import clsx from 'clsx'
import Link from 'next/link'
import { useRouter } from 'next/router'

const AccountNav = () => {
  const { route } = useRouter()
  const { handleLogout } = useAccount()

  return (
    <div>
      <div className="small:hidden">
        {route !== '/account' && (
          <Link href="/account">
            <div className="flex items-center gap-x-2 text-small-regular py-2">
              <ChevronDown className="transform rotate-90" />
              <span>Account</span>
            </div>
          </Link>
        )}
      </div>
      <div className="hidden small:block">
        <div>
          <div className="py-4">
            <Text textStyle={'accountTitle'}>Account</Text>
          </div>
          <div className="text-base-regular mt-3">
            <ul className="flex mb-0 justify-start items-start flex-col gap-y-4">
              <li>
                <AccountNavLink href="/account" route={route}>
                  Overview
                </AccountNavLink>
              </li>
              <li>
                <AccountNavLink href="/account/profile" route={route}>
                  Profile
                </AccountNavLink>
              </li>
              <li>
                <AccountNavLink href="/account/addresses" route={route}>
                  Addresses
                </AccountNavLink>
              </li>
              <li>
                <AccountNavLink href="/account/orders" route={route}>
                  Orders
                </AccountNavLink>
              </li>
              <li className="text-grey-700">
                <Text textStyle={'accountMedium'} color={'black.500'}>
                  <button type="button" onClick={handleLogout}>
                    Log out
                  </button>
                </Text>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

type AccountNavLinkProps = {
  href: string
  route: string
  children: React.ReactNode
}

const AccountNavLink = ({ href, route, children }: AccountNavLinkProps) => {
  const active = route === href
  return (
    <Link href={href}>
      <Text
        textStyle={active ? 'accountMediumBold' : 'accountMedium'}
        color={active ? 'black' : 'black.500'}
        mb={3}
      >
        {children}
      </Text>
    </Link>
  )
}

export default AccountNav
